module.exports = __webpack_public_path__ + "img/10.fe349e85.jpeg";